import { render, staticRenderFns } from "./BuroCreditoList.vue?vue&type=template&id=6bcc1a8b&scoped=true&"
import script from "./BuroCreditoList.vue?vue&type=script&lang=js&"
export * from "./BuroCreditoList.vue?vue&type=script&lang=js&"
import style0 from "./BuroCreditoList.vue?vue&type=style&index=0&id=6bcc1a8b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc1a8b",
  null
  
)

export default component.exports